/** Build an Unsplash image URL from a stable photo id. */
export function unsplash(id: string, opts: { w?: number; q?: number; fit?: 'crop' | 'max' } = {}): string {
  const { w = 1200, q = 80, fit = 'crop' } = opts;
  return `https://images.unsplash.com/${id}?w=${w}&q=${q}&fit=${fit}&auto=format`;
}

/** Curated Kashmir-evocative photo ids. Same ids as the design package. */
export const photo = {
  snowPeaks: 'photo-1464822759023-fed622ff2c3b',
  mountainLake: 'photo-1506905925346-21bda4d32df4',
  pineForest: 'photo-1441974231531-c6227db76b6e',
  aerialPeaks: 'photo-1469474968028-56623f02e42e',
  autumnRoad: 'photo-1500382017468-9049fed747ef',
  winterTrek: 'photo-1493246507139-91e8fad9978e',
  alpineRidge: 'photo-1454496522488-7a8e488e8606',
  trekker: 'photo-1551632811-561732d1e306',
  campingTent: 'photo-1504280390367-361c6d9f38f4',
  boat: 'photo-1454391304352-2bf4678b1a7a',
  meadow: 'photo-1519681393784-d120267933ba',
  skier: 'photo-1551698618-1dfe5d97d256',
  reflection: 'photo-1426604966848-d7adac402bff',
  valley: 'photo-1486870591958-9b9d0d1dda99',
  flowers: 'photo-1473773508845-188df298d2d1',
  road: 'photo-1502082553048-f009c37129b9',
  cliff: 'photo-1483728642387-6c3bdd6c93e5',
  guideM1: 'photo-1507003211169-0a1dd7228f2d',
  guideM2: 'photo-1500648767791-00dcc994a43e',
  guideF1: 'photo-1438761681033-6461ffad8d80',
  guideF2: 'photo-1487412720507-e7ab37603c6f',
  guideM3: 'photo-1472099645785-5658abf4ff4e',
  guideF3: 'photo-1494790108377-be9c29b29330',
} as const;
